@if (!router.url.startsWith('/2500-8-report') && !router.url.startsWith('/report-accomplishment')) {
  <app-header></app-header>
}
<router-outlet></router-outlet>
@if (!router.url.startsWith('/2500-8-report') && !router.url.startsWith('/report-overview') && !router.url.startsWith('/report-accomplishment')) {
  <app-footer></app-footer>
}